import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import _get from 'lodash/get';
import { hooks } from '@lifesize/clients.sdk';
import { moderatorActions } from '@lifesize/nucleus';
import { colors } from '@lifesize/ux-assets';
import { ReactComponent as HandIcon } from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import { makeStyles, Theme } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';

export const LowerHandsButton = () => {
  const classes = useStyles({});
  const raisedHands = hooks.useParticipantsWithRaisedHands();
  const raisedHandsCount = _get(raisedHands, 'length', 0);
  const dispatch = useDispatch();

  const handleLowerAllHandsClicked = () => {
    dispatch(moderatorActions.lowerAllRaisedHands());
  };

  return (
    <button
      className={classes.button}
      data-testid="btnLowerAllHands"
      disabled={!raisedHandsCount}
      onClick={handleLowerAllHandsClicked}
    >
      <HandIcon />
      <span>
        <FormattedMessage id="components.inCall.lowerAllHands" defaultMessage="Lower All Hands" />
      </span>
    </button>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    alignItems: 'center',
    borderWidth: '1px 0 0!important',
    borderColor: `${colors.sentinel}!important`,
    borderStyle: 'solid!important',
    border: 0,
    display: 'flex',
    flexDirection: 'row',
    fontSize: '1em',
    justifyContent: 'flex-start',
    minHeight: 38,
    outline: 0,
    padding: `${theme.spacing(0.75)}px ${theme.spacing(3)}px`,
    position: 'relative',
    width: '100%',

    '& svg': {
      color: colors.lifesizeBlue,
      flex: '0 0 auto',
      height: '2.6em',
      marginRight: theme.spacing(2)
    },
    '& > span': {
      color: colors.squidInk,
      fontSize: '1.4em',
      fontWeight: theme.typography.fontWeightBold,
      textAlign: 'left'
    },
    '&:hover:not(:disabled)': {
      backgroundColor: fade(colors.lifesizeBlue, 0.2)
    },
    '&:disabled': {
      cursor: 'default',
      '& svg': {
        color: fade(colors.lifesizeBlue, 0.5)
      },
      '& > span': {
        color: fade(colors.squidInk, 0.5)
      }
    }
  }
}));

export default LowerHandsButton;
